import { api } from "@lumberset/api-client";
import { TicketDetail } from "@lumberset/support-ui";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Crumbs } from "../../../components/crumbs";
import { supportTicketQuery } from "../../../lib/queries";

export const Route = createFileRoute("/_app/support/tickets/$id")({
  loader: ({ context: { queryClient }, params }) =>
    queryClient.ensureQueryData(supportTicketQuery(params.id)),
  component: TicketScreen,
});

function TicketScreen() {
  const { id } = Route.useParams();
  const { user } = Route.useRouteContext();
  const navigate = useNavigate();
  const { data } = useSuspenseQuery(supportTicketQuery(id));
  return (
    <>
      <Crumbs trail={[{ label: "Support", to: "/support" }, { label: data.ticket.title }]} />
      <TicketDetail
        client={api}
        id={id}
        me={{ id: user.id, name: user.name }}
        // The Help Article editor drafts from the Ticket it is given.
        onTurnIntoArticle={(ticketId) =>
          navigate({ to: "/help/articles/new", search: { ticketId } })
        }
      />
    </>
  );
}
